export const DEFAULT_STYLES = {
   TEXT_COLOR: '#000000',
   BACKGROUND_COLOR: '#ffffff',
   FONT_FAMILY: 'Helvetica',
   FONT_SIZE: '16px',
   LINE_HEIGHT: '1.4',
   TEXT_ALIGN: 'left',
} as const;